import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

/**
 * Static title + description block, shared between the section and its loading
 * skeleton so keyboard/screen-reader users get the real header before the
 * lazy-loaded content resolves.
 */
export const TrendingSectionHeader: React.FC<EmptyProps> = () => (
	<div className="flex flex-col gap-4">
		<Text
			className="m-0"
			as="h2"
			id="trending-section-title"
			data-qa="homepage-trending-section-title"
			variant="heading"
			size="large"
		>
			<Translate value="corgi.homepage.trending_section.title" />
		</Text>
		<Text>
			<Translate value="corgi.homepage.trending_section.description" />
		</Text>
	</div>
);
